// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"328":"d467e8a3","404":"52c85d0a"}[chunkId] + ".js";
};